import { useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import { OutputCellModal } from './OutputCellModal';

interface OutputCellNodeProps {
  data: { newNodeId: string; outputCellValue: number; processMapId: string };
}

export const outputCellNodeStyles = {
  width: 50,
  height: 50,
  borderRadius: '50%',
  backgroundColor: 'white',
  border: '2px solid black',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontSize: '14px',
  color: 'black',
  boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.2)',
};

export const OutputCellNode: React.FC<OutputCellNodeProps> = ({ data }) => {
  const [displayOutputCellModal, setDisplayOutputCellModal] =
    useState<boolean>(false);

  const onCancelModal = () => {
    setDisplayOutputCellModal(false);
  };

  return (
    <>
      <div
        style={{
          minWidth: 50,
          minHeight: 50,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={() => setDisplayOutputCellModal(true)}
      >
        {data.outputCellValue}
        <Handle type="target" position={Position.Top} isConnectable={false} />
        <Handle
          type="source"
          position={Position.Bottom}
          isConnectable={false}
        />
      </div>

      {displayOutputCellModal && (
        <OutputCellModal
          outputCellId={data.newNodeId}
          planId={data.processMapId}
          open={displayOutputCellModal}
          onCancel={onCancelModal}
        />
      )}
    </>
  );
};
